export default {"src":"/_next/static/media/noFilesImage.53b3ea24.svg","height":141,"width":171,"blurWidth":0,"blurHeight":0};